import React from 'react'
import { graphql } from 'babel-plugin-relay/macro'
import { ContactEmailsQuery } from '../../__generated__/ContactEmailsQuery.graphql'
import EmailsTab from '../../components/Email/EmailsTab'
import useLazyLoadQueryWithSubscription from '../../hooks/useLazyLoadQueryWithSubscription'

const ContactEmails: React.FC<{ slug: string }> & { Skeleton: React.FC } = ({ slug }) => {
  const queryData = useLazyLoadQueryWithSubscription<ContactEmailsQuery>(
    contactQuery,
    { slug },
    { subscriptionOptions: { entityType: 'contacts', entitySlug: slug } }
  )

  return <EmailsTab emails={queryData.contactShow.emails} entityType='contacts' entitySlug={slug} />
}

const contactQuery = graphql`
  query ContactEmailsQuery($slug: String!) {
    contactShow(slug: $slug) {
      emails {
        ...EmailsTab_emails
      }
    }
  }
`

ContactEmails.Skeleton = () => <EmailsTab.Skeleton />

export default ContactEmails
